import IEtnia from '../../interfaces/IEtnia';
import IEtniaParaSelect from '../../interfaces/IEtniaParaSelect';

export const mapearEtniaParaSelect = (gruposEtnicos: IEtnia[]): IEtniaParaSelect[] =>
  gruposEtnicos.map(({ id, nome, ehIndigena }) => ({
    value: id,
    label: nome,
    ehIndigena: ehIndigena
  }));